<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="Requirement">
      <div class="requirement-detail-box">
        <div class="requirement-detail">
          <div class="breadcrumb_box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/circle">圈子</a></el-breadcrumb-item>
          <el-breadcrumb-item>发布体验课作业</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="requirement-main" >
        <div class="requirement-work-title">作业名称：{{des.title}}</div>
        <div class="requirement-course-title">课程名称：{{des.title}}</div>
        <div class="requirement-main-box">
          <div class="requirement-main-teacher">
            <div class="head-image-box">
              <img :src="des.images" alt="">
            </div>
            <div class="head-image-box2">
              <img src="https://www.dapengjiaoyu.cn/dapeng/img/266362e.1660726626187.png" class="main-info-icon" alt="">
              <p class="main-info-nickname">{{des.teacher_name}}</p>
            </div>
          </div>
          <div class="requirement-main-time">
            <p>授课时间：{{des.create_time}}</p>
            <P>截止时间：{{des.end_time}}</P>
          </div>
        </div>
        <div class="requirement-content">
          <div class="requirement-content-title">作业要求：</div>
          <div class="requirement-content-msg">{{des.content}}</div>
        </div>
      </div>
      <div class="requirement-img">
        <!-- <img src="https://image.dapengjiaoyu.com/2022-08-23/kitoerfrwn/5470143521661_UEPlkI7lj7A=.jpg" alt=""> -->
        {{des.media}}
      </div>

      <div class="student-homework">
        <div class="student-homework-title">同学作业</div>
        <div class="homework-lists">
          <div class="list-img-box">
            <div class="less-than-four">
              <div class="homework-lists_flex">
                <div class="less-than-four-img">
                  <img src="https://image.dapengjiaoyu.com/2022-08-23/kd3shvywet/2286521661_SDU=.jpg?x-oss-process=style/400x400lb" alt="">
                </div>
                <div class="less-than-four-content">
                  <div class="user-content">
                    <div class="head-image-box">
                      <img src="	https://image.dapengjiaoyu.com/images/avatars/38avatar.jpg" alt="">
                    </div>
                    <div class="user-content-bottom">
                      <p>林书峰</p>
                      <p> 1小时前</p>
                    </div>

                  </div>
                    <div class="page-detail-card ">
                      <span class="card-work-link">
                        <i class="work-link-icon"></i>
                        <span class="card-work-link-msg">芸书2022期8.23---《一心一意》隶书曹全碑</span>
                        <i class="work-link-to-icon"></i>
                      </span>
                    </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        </div>
        <div class="requirement-submitCount">
          <p class="submitCounts">13</p>
          <p>已提交作业（份）</p>
          <p class="publishHomeworks">发布作业</p>
        </div>
      </div>
      
      
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>
<script>
import Menu from '@/components/view/Menu'
import Footer from '@/components/view/Footer'
export default {
  name: 'Requirement',
  components: {
    Menu,
    Footer
  },
  data() {
    return {
      des: {
        title: "",
        images: [],
        teacher_name:'',
        create_time:'',
        end_time:'',
        content:'',
        media:''
      },
    }
  },
  created() {
    this.Requirement()
  },
  methods:{
     Requirement() {
      this.$axios({
        method: 'post', // 请求格式
        url: '/api/homework/content', // 请求路径
        headers: { // 设置请求头
          token: this.$cookieStore.getCookie('token')
        },
        data: { "chapter_id": "1" }
      }).then(res => {
        // console.log(200)
        this.des = res.data.data
        // console.log(this.requirements);
        // console.log(this.userList)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.Requirement{
  padding: 0px;
  margin: 0px;
  width: 1200px;
  margin: 0 auto;
}
  .requirement-detail-box{
    display: flex;
  }
  .requirement-detail{
    width: 780px;
    margin-left: 127px;
    margin-top: 32px;
    position: relative;
  }
  .requirement-submitCount{
    width: 247px;
    height: 218px;
    background: #f5f8f8;
    border-radius: 8px;
    position: -webkit-sticky;
    position: sticky;
    top: 103px;
    padding: 50px 0 24px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Medium,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
    font-weight: 500;
    color: #18252c;
    text-align: center;
    z-index: 99;
    margin-left: 20px;
  }
    .submitCounts{
      font-size: 28px;
    }
    .publishHomeworks{
      width: 195px;
      height: 40px;
      margin: 36px auto 0;
      line-height: 40px;
      background: linear-gradient(316deg,#FABE00,#1cdc94);
      border-radius: 6px;
      font-size: 16px;
      font-family: PingFangSC-Medium,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
      font-weight: 500;
      color: #fff;
      text-align: center;
      cursor: pointer;
      position: relative;
    }
  .content_top {
    padding: 20px 0;
  }
  .requirement-main{
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
    text-align: left;
  }
    .requirement-work-title{
      font-size: 20px;
      font-family: PingFangSC-Semibold,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
      font-weight: 600;
      color: #18252c;
      margin-bottom: 16px;
    }
    .requirement-course-title{
      font-size: 16px;
      font-family: PingFangSC-Medium,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
      font-weight: 500;
      color: #18252c;
      margin-bottom: 24px;
    }
    .requirement-main-box{
      display: flex;
      justify-content: space-between;
    }
      .requirement-main-teacher{
        margin-bottom: 23px;
      }
        .head-image-box{
          float: left;
        }
        .head-image-box2{
          float: left;
        }
          .head-image-box img{
            height: 45px;
            width: 45px;
            border-radius: 50%;
            vertical-align: middle;
            -o-object-fit: cover;
            object-fit: cover;
            cursor: pointer;
          }
          .main-info-icon{
            margin-left: 8px;
          }
          .main-info-nickname{
            margin-left: 12px;
            margin-top: 5px;
            font-size: 14px;
            font-family: PingFangSC-Medium,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
            font-weight: 600;
            color: #18252c;
          }
    .requirement-main-time{
      height: 61px;
      background: #fff8f1;
      border-radius: 6px;
      margin-top: -8px;
      padding: 8px 16px;
      box-sizing: border-box;
    }
    .requirement-main-time P{
      font-size: 14px;
      font-family: PingFangSC-Regular,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
      font-weight: 400;
      color: #36404a;
    }
    .requirement-content{
      width: 780px;
      background: #f5f8f8;
      border-radius: 6px;
      padding: 12px 16px;
      box-sizing: border-box;
      margin-bottom: 24px;
    }
      .requirement-content-title{
        font-size: 16px;
        font-family: PingFangSC-Semibold,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
        font-weight: 600;
        color: #18252c;
        margin-bottom: 10px;
      }
      .requirement-content-msg{
        font-size: 14px;
        font-family: PingFangSC-Regular,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
      }
      .requirement-img{
        width: 780px;
        height: 527px;
        border-radius: 8px;
        position: relative;
      }
        .requirement-img img{
          width: 100%;
          height: 100%;
          border-radius: 8px;
          -o-object-fit: cover;
          object-fit: cover;
          cursor: pointer;
        }

      .student-homework,.homework-lists{
        margin: 20px 0;
      }
        .student-homework-title{
          font-size: 20px;
          font-family: PingFangSC-Semibold,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
          font-weight: 600;
          color: #1a3743;
          text-align: left;
        }
        .homework-lists_flex{
          position: relative;
          display: flex;
          height: 195px;
        }
          .less-than-four-img{
            position: relative;
            width: 260px;
            height: 195px;
            overflow: hidden;
            border-radius: 5px;
            cursor: pointer;
          }
           .less-than-four-img img{
              width: 100%;
              height: 100%;
              -o-object-fit: cover;
              object-fit: cover;
            }
          .less-than-four-content{
            flex: 1;
            margin-left: 12px;
            position: relative;
            cursor: pointer;
          }
            .user-content{
              display: flex;
              position: relative;
            }
              .head-image-box img{
                height: 40px;
                width: 40px;
                border-radius: 50%;
              }

            .user-content-bottom{
              margin-left: 8px;
            }
              .user-content-bottom p{
                font-size: 14px;
                font-family: PingFangSC-Medium,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
                font-weight: 600;
                color: #18252c;
                line-height: 20px;
              }
            .page-detail-card {
              height: 24px;
              cursor: auto;
              text-align: left;
              margin-top: 15px;
            }
            .card-work-link{
              padding: 0 32px 0 26px;
              display: inline-block;
              height: 24px;
              line-height: 24px;
              background: #e6f7ee;
              border-radius: 12px;
              font-size: 12px;
              font-family: PingFangSC-Regular,PingFang SC,Helvetica,STHeiti,Microsoft YaHei,"sans-serif";
              font-weight: 400;
              color: #FABE00;
              cursor: pointer;
              position: relative;
            }
              .work-link-icon{
                position: absolute;
                display: inline-block;
                transform: translateY(-50%);
                top: 50%;
                left: 8px;
                width: 14px;
                height: 14px;
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABjklEQVQ4T21SPUtcURA9E8iGgEWE+LFabqWFaJUyRQqbYCCNre8HaBMJBJ4gCkZDCGIjSrqQXoh1CsUP0MSgaIi/IFVkkUXd3XuO3H1737sGbzXM3DPnzJmx/vOVTYjPSG4L7vtVo/m1OvTuAtHrOpgZgeE1oOcShyGuW9+fZYI0iYAIif8ALv21+nKn1PuwYStyfNWu+ToMvLG+35+Ug9gChgZViI9FltDOi1kNcrDy2Ue1usWg9ofso4OkrCF97HOClU8/6D4QxD2KT0AOBECszHpPFu9nNCV0zQqoNGP1jMUo1nO8oDgR5EFKSFeBmMagEFvPr3n5GbI5ixnkmACuIjH935yWs91Hc2pJCYYUkhKRFYBp7kGQSg/8OSvPlO8pWE6XyDMSBWM0p3X9mLkG+cjTx6ySVuFcv8Cx3IOwT9HZ08P0jZETlBsE+eAOOJZf7Lph4GcLJ9mxM91dMr6UNAly+M7M0rHoNhy5VVN9H6Nfajkwv2nBOnenxtVovpdwTbq3ly/WvsVH7+Nbv9zQFghmCOEAAAAASUVORK5CYII=) 100% 100% no-repeat;
              }
              .card-work-link-msg{
                max-width: 360px;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .work-link-to-icon{
                position: absolute;
                display: inline-block;
                transform: translateY(-50%);
                top: 50%;
                right: 8px;
                width: 12px;
                height: 12px;
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAoUlEQVQoU2NkQAabfbm4mTj4vnqvfoEijsRhRJbg2Ra9/z8Dg8V/Rqbgb56Lt2HThK6hn4GBoeA/w/+f/xmZg7BpQtHA8J+BkXt79BxGBoak/4wMP/4zMQR9c1+6HdkmVA0gGQKaMDVg0cT4n8H4i9fSayAp3Bp2Rs9h/AdxGn4NJDmJVE/zbo3p+8/4v5DoYOXZFrP3P8N/K6IjjoGIpAEAiKliDZrIgE8AAAAASUVORK5CYII=) 100% 100% no-repeat;
              }
              
</style>



// WEBPACK FOOTER //
// src/components/Demo.vue